<template>
    <div class="container px-2">
        <carousel
            :perPage="1"
            :paginationEnabled="false"
            :navigationEnabled="true"
            :navigationPrevLabel="prevLabel"
            :navigationNextLabel="nextLabel"
        >
            <slide v-for="(slide, i) in slides" :key="i">

                <div class="col w-full md:w-3/4 mx-auto md:px-4 py-3 pb-5 text-center">

                    <div class="bg-white md:p-3 text-center border-box h-full">
                        <img v-if="slide.image" :src="slide.image['sizes']['medium']" :alt="slide.alt" class="rounded-full mb-2" />
                        <p class="pt-2 font-300 text-sm leading-loose mb-3">{{ slide.content }}</p>
                        <h3 class="font-400 capitalize mb-2">{{ slide.title }}</h3>
                        <p class="font-300 text-sm">{{ slide.sub_title }}</p>
                    </div>

                </div>

            </slide>
        </carousel>
    </div>
</template>

<script>
    // Import the entire module instead of destructuring
import VueCarousel from 'vue-carousel';

    export default {

        name: 'CarouselQuotes',

        components: {
            'carousel': VueCarousel.Carousel,
            'slide': VueCarousel.Slide,
        },

        props: {
            slides: {
                type: Array,
                default() {
                    return [];
                },
            },
        },

        computed: {
            prevLabel() {
                return "<span class='text-6'>&lsaquo;</span>";
            },

            nextLabel() {
                return "<span class='text-6'>&rsaquo;</span>";
            },
        },

    }
</script>

<style>
    .VueCarousel-navigation--disabled {
        display: none;
    }

    @media (max-width: 420px) {
        .VueCarousel-navigation {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// web/app/themes/giles/resources/js/components/CarouselQuotes.vue